module.exports = __webpack_public_path__ + "static/img/yycj_02.11bcaaf.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/yycj_02.png
// module id = rdua
// module chunks = 2